module.exports = __webpack_public_path__ + "static/media/rackets_500.7834471f.jpg";